/**
 * Prompt Submission controller - handles prompt submission logic
 */

import * as addPromptService from '../../data/services/addPromptService';

/**
 * Submit prompt to library
 * @param {Object} submissionData - Prompt submission data
 * @param {string} userId - User ID
 * @param {string} organizationId - Organization ID
 * @param {Object} user - Optional user object (if available from context)
 * @returns {Promise<Object>} Created prompt
 */
export const submitPromptToLibrary = async (submissionData, userId, organizationId, user = null, isGlobal = false) => {
  return await addPromptService.submitPrompt(submissionData, userId, organizationId, user, isGlobal);
};

